module.exports = __webpack_public_path__ + "components/country-flag/static/gn-fc749c6111b384019f9a93c79393c9c3.svg";